import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

import '../style/services.css'
import HomeCarousel from '../components/homeCarousel';

function Services(){
    const { t } = useTranslation();

    // Using the translation structure for services
    const servicesData = t('services.items', { returnObjects: true });

    return(
        <section id="services" className="block services-block">
            <Container fluid>
                <div className='title-holder'>
                    <h2>{t('services.title')}</h2>
                    <div className='subtitle'>{t('services.subtitle')}</div>
                </div>
                {/* <HomeCarousel /> */}
                <Row>
                    {
                        servicesData.map(
                            (service, index) => {
                                return(
                                    <Col sm={4} className='holder' key={index}>
                                        <div className='icon'>
                                            <i className={service.icon || 'fas fa-life-ring'}></i>
                                        </div>
                                        <h3>{service.title}</h3>
                                        <p>{service.description}</p>
                                    </Col>
                                );
                            }
                        )
                    }
                </Row>
            </Container>
        </section>
    );
}

export default Services;